import { Route, Routes, BrowserRouter } from 'react-router-dom';
import Auth from './Auth';
import Home from './Home';
import Layout from './Layout';
import Category from './Category';
import User from './User';
import Menu from './Menu';
import { RecoilRoot } from 'recoil';
import Report from './Report';
import Providers from '~/providers';
import PaymentAccount from './PaymentAccount';
import PriceRounding from './PriceRounding';
import PrintServer from './PrintServer';
import Printer from './PrinterV2';
import Role from './Role';
import UserRole from './UserRole';
import RestaurantLevelLayout from './Layout/RestaurantLevelLayout';
import Order from './Order';

const App = () => {
  return (
    <RecoilRoot>
      <BrowserRouter>
        <Providers>
          <Routes>
            <Route path="auth/*" element={<Auth />} />
            <Route path="" element={<Layout />}>
              <Route index element={<Home />} />
              <Route path="user/*" element={<User />} />
              <Route path="restaurant" element={<RestaurantLevelLayout />}>
                <Route path="categories" element={<Category />} />
                <Route path="menus/*" element={<Menu />} />
                <Route path="report" element={<Report />} />
                <Route path="payment-account/*" element={<PaymentAccount />} />
                <Route path="price-rounding" element={<PriceRounding />} />
                <Route path="print-server" element={<PrintServer />} />
                <Route path="printer/*" element={<Printer />} />
                <Route path="role/*" element={<Role />} />
                <Route path="user-role/*" element={<UserRole />} />
                <Route path="order/*" element={<Order />} />
              </Route>
            </Route>
          </Routes>
        </Providers>
      </BrowserRouter>
    </RecoilRoot>
  );
};

export default App;
